module.exports = __webpack_public_path__ + "img/1.b1baa74f.jpg";